export { default } from './SpecialPagesService';



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/specialPages/services/SpecialPagesService/index.js